import React, { useEffect, useState } from "react";
import moment from "moment";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  compareDate,
  noDataFound,
} from "../../../CommonMethhods/CommonMethods";
import { Dashboard_Client_Report } from "../../../Configuration/API_URL";
import SmallLoader from "../../../Components/Common/smallLoader";
import { Constants } from "../../../CommonMethhods/Constants";
import Loader from "../../../Components/Common/Loader";
import ContractListTable from "../../../Components/ReportTables/ContractListTable";
import warningIcon from "../../../asset/images/icons/warning.svg";
import errorImage from "../../../asset/images/icons/errorImage.svg";
import { Col, Row, Toast } from "react-bootstrap";
import FromdateComponent from "../../Reports/FromdateComponent";
import TodateComponent from "../../Reports/TodateComponent";
import { toast } from "react-toastify";
import DurationChangeComponent from "../../Reports/DurationChangeComponent";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

function ContractListReportNew(props) {
  const seg = "stocks";
  const storeToken = localStorage.getItem("ssoToken");
  const [data, setData] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loader, setLoader] = useState(false);
  const [checkDate, setCheckDate] = useState(false);
  const [smallLoaderMail, setSmallLoaderMail] = useState(false);
  // const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [error, setError] = useState("");
  const [serverError, setServerError] = useState(false);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [userFriendList, setUserFriendList] = useState([]);
  const [userFriendlyName, setUserFriendlyName] = useState([]);
  const [mailError, setMailError] = useState("");
  const [customShow, setCustomShow] = useState(false)
  let newArr = [];
  const ClientId2 = localStorage.getItem("ClientId2");


  if (fromDate == "" || toDate == "") {
    // const current = new Date();
    // const CurrentYear = current.getFullYear();
    // const CurrentMonth = current.getMonth();
    // if (CurrentMonth < 4) {
    //   const newYear = `04-01-${CurrentYear - 1}`;
    //   const date = `${current.getMonth() + 1
    //     }-${current.getDate()}-${current.getFullYear()}`;
    //   const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
    //   setFromDate(newYear);
    //   setToDate(date1);
    // } else {
    //   const newYear = `04-01-${CurrentYear}`;
    //   const date = `${current.getMonth() + 1
    //     }-${current.getDate()}-${current.getFullYear()}`;
    //   const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
    //   setFromDate(newYear);
    //   setToDate(date1);
    // }
    let date = new Date();
        let firstDay = "";
        let lastDay = "";
        let firstVal = new Date(date.getFullYear(), date.getMonth(), 1);
        firstDay = moment(firstVal, "MM-DD-YYYY").format("MM-DD-YYYY");
        let lastVal = new Date();
        lastDay = moment(lastVal, "MM-DD-YYYY").format("MM-DD-YYYY");
        setFromDate(firstDay)
        setToDate(lastDay)
  }
  const getContractListReport = async (fileType, e) => {
    if (fileType === "mail") {
      setSmallLoaderMail(true);
      setLoader(false);
    }
    if (fileType === "grid") {
      setSmallLoaderMail(false);
      setLoader(true);
    }
    let payloadValue = {
      clientCode: localStorage.getItem("clientCode") || ClientId2,
      fromDate: fromDate,
      toDate: toDate,
      seg: seg,
      fileType: fileType,
      userContractName: e ? [e] : userFriendList,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axiosInstance.post(
        Dashboard_Client_Report.GetContractList_URL,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetails?.data);


      if (res?.status === 0) {
        setServerError(false);
        if (fileType === "grid") {
          setData(res?.data);
        } else if (fileType === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
          toast.success("File downloaded successfully");
        } else if (fileType === "mail") {
          toast.success(res?.data);
        }
      } else {
        if (fileType !== "grid") {
          toast.error(res?.message);
        }
        if (fileType === "grid") {
          setData([]);
          setServerError(res?.message);
        }
      }
    } catch (error) {
      console.log(error);
      setServerError(error?.message);
      if (fileType !== "grid") {
        toast.error(error?.message);
      }
    } finally {
      setLoader(false);
      setSmallLoaderMail(false);
    }
  };

  const handleFromDateChange = (e) => {
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(d);
    // setData([]);
    setError("");
    setMailError("");
    setServerError(false);
  };
  const handleToDateChange = (e) => {
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    // setData([]);
    setError("");
    setMailError("");
    // setFileType("")
    setServerError(false);
  };
  useEffect(() => {
    if (localStorage.getItem("clientCode") || ClientId2) {
      if (
        compareDate(fromDate) &&
        compareDate(toDate) &&
        checkDateRange(fromDate, toDate)
      ) {
        getContractListReport("grid");
      } else {
        setCheckDate(true);
      }
    }
  }, []);

  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }
  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  const handleOnClick = (e) => {
    if (fromDate.length > 0 && toDate.length > 0) {
      if (e.target.value) {
        if (
          compareDate(fromDate) &&
          compareDate(toDate) &&
          checkDateRange(fromDate, toDate)
        ) {
          getContractListReport(e.target.value);
          setError("");
          setMailError("");
          setCheckDate(false);
        } else {
          setCheckDate(true);
          setError("Please Select Correct Date.");
        }
      }
    }
  };

  function getMailData() {
    if (userFriendList.length > 0) {
      getContractListReport("mail");
      // setIsCheckAll(false)
      setUserFriendList([]);
    } else {
      setMailError("Please Select at least one Contract Report");
      setError("");
    }
  }

  function selectAllDeleteSymbolList() {
    setIsCheckAll(!isCheckAll);
  }
  async function handleDownloadDocument(e, id) {
    setUserFriendList([]);
    const oldData = [...data];
    const loaded = oldData.map((item, key) => {
      console.log(id === key, "key");
      if (id === key) {
        item.loader = true;
      } else {
        item.loader = false;
      }
      return item;
    });
    if (e) {
      setData(loaded);

      // setTimeout(() => {
      setMailError("");
      await getContractListReport("pdf", e);

      const oldData = [...data];
      const newloaded = oldData.map((item) => {
        item.loader = false;

        return item;
      });

      setData(newloaded);

      // }, 5000);
    }
  }

  function handleSelectionChange(e) {
    setMailError("");
    setIsCheckAll(false);
    if (data.length >= userFriendList.length) {
      document.getElementById("select-all").checked = false;
    }
    const { value, checked } = e.target;
    if (checked) {
      setUserFriendList((preval) => [...preval, value]);
    } else {
      let newArr = userFriendList.filter((item) => item !== value);
      setUserFriendList(newArr);
    }
  }

  function getAllDeleteSymbol() {
    if (isCheckAll) {
      data.map((item) => {
        newArr.push(`${item.userFriendlyName}`);
      });
      setUserFriendList(newArr);
    } else {
      if (data.length <= userFriendList.length) {
        setUserFriendList([]);
        setUserFriendlyName([]);
      }
    }
  }

  const onChangeDuration=()=>{
    setError("");
    setMailError("");
    setServerError(false);
  }

  useEffect(() => {
    getAllDeleteSymbol();
  }, [isCheckAll]);

  return (
    <>
      <div
        className="tab-pane fade show active"
        id="contract-list"
        role="tabpanel"
        aria-labelledby="contract-list"
      >
        <div className="reports-date-filter">
          <div className="reports-left-form">
            <form>
              <div className="report-form-wrapper">
                <div className="form-group" >
                  <DurationChangeComponent
                    setCustomShow={setCustomShow}
                    setFromDate={setFromDate}
                    setToDate={setToDate}
                    className="report-custom-select"
                    onChangeDuration={onChangeDuration}
                    screen="Client Dashboard"
                  />
                </div>
                {customShow && <FromdateComponent
                  fromDate={handleFromDateChange}
                  formatDate={formatDate(fromDate)}
                  DateReverse={DateReverse}
                />}

                {customShow && <TodateComponent
                  toDate={handleToDateChange}
                  formatToDate={formatDate(toDate)}
                  DateReverse={DateReverse}
                  errorResponse={error}
                />}
              </div>
            </form>
            <button
              className="generate-button get-data"
              value="grid"
              onClick={handleOnClick}
            >
              {Constants.Submit}
            </button>
            <button
              className="generate-button mail-btn mt-2"
              value="mail"
              onClick={getMailData}
            >
              {smallLoaderMail ? (
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-email"></span>
                  E-Mail
                </>
              )}
            </button>
          </div>
        </div>
        <div className="report-btn-wrapper">
          <p className="mail-error">{mailError}</p>
        </div>
      </div>
      {loader ? (
        <div className="loader-alignment">
          <Loader />
        </div>
      ) : (
        data.length > 0 && (
          <div>
            <ContractListTable
              data={data}
              selectAllDeleteSymbolList={selectAllDeleteSymbolList}
              handleSelectionChange={handleSelectionChange}
              handleDownloadDocument={handleDownloadDocument}
              userFriendList={userFriendList}
            />
          </div>
        )
      )}
      {serverError && (
        <div className="report-error-message">{noDataFound(serverError)}</div>
      )}
    </>
  );
}
export default ContractListReportNew;
